<mat-card class="flex-col flex" *cbWaitFor="mappedItem?.id > 0">
    <mat-card-header>
        <mat-card-title>{{ mappedItem.name }}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <cb-display-value-new
            label="Status"
            [value]="mappedItem.statusLabel"
        ></cb-display-value-new>
        <cb-display-value-new
            label="Complexity"
            [value]="mappedItem.designComplexityLabel"
        ></cb-display-value-new>
        <cb-display-value-new
            label="Assigned To"
            [value]="mappedItem.assignedToName"
        ></cb-display-value-new>
        @if (mappedItem.reviewerName && mappedItem.designReviewRequired) {
            <cb-display-value-new
                label="Reviewer"
                [value]="mappedItem.reviewerName"
            ></cb-display-value-new>
        }
        <cb-display-value-new
            label="Due Date"
            [value]="mappedItem?.dueDate | date"
        ></cb-display-value-new>
        <cb-elapsed-time
            label="Elapsed Time"
            [elapsedTime]="elapsedTime"
            [counting]="mappedItem.statusId == WORKING_DRAWING_STATUS_ENUM.InProgress"
        >
        </cb-elapsed-time>
        <form class="flex-col flex" #workingDrawingChangesForm="ngForm">
            <div style="overflow-y: auto">
                @for (change of mappedItem.changes; track change) {
                    <div
                        class="flex-row"
                        style="
                            border-color: rgba(0, 0, 0, 0.12);
                            border-style: solid;
                            border-width: 0 0 1px;
                        "
                    >
                        <div class="flex-col flex" layout-padding>
                            <div class="flex-row start-center">
                                <cb-working-drawing-change-status-checkbox
                                    [changeStatus]="change.statusId"
                                    [edit]="isChangeBeingEdited(change.id)"
                                    (statusUpdated)="statusUpdated(change, $event)"
                                >
                                </cb-working-drawing-change-status-checkbox>
                                <mat-icon class="cb-margin-right">message</mat-icon>
                                <span class="mat-body-strong cb-margin-right">
                                    {{ change.changeNumber }}:
                                </span>
                                <span class="mat-body-2 flex">
                                    {{ change.changeRecordDetails }}
                                </span>
                                <div class="flex-row center-center">
                                    @if (isChangeBeingEdited(change.id)) {
                                        <button
                                            mat-button
                                            class="mat-accent"
                                            (click)="changeSaveClicked(change)"
                                        >
                                            Save
                                        </button>
                                        <button mat-button (click)="changeCancelClicked(change)">
                                            Cancel
                                        </button>
                                    } @else {
                                        <button
                                            mat-button
                                            class="mat-icon-button"
                                            [disabled]="isEditWorkingDrawingChangeDisabled()"
                                            (click)="changeEditClicked(change)"
                                        >
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                    }
                                </div>
                            </div>
                            <cb-text-area
                                class="flex"
                                name="{{ change.changeNumber }}_changeComments"
                                [(ngModel)]="change.comments"
                                [maxlength]="1024"
                                [readonly]="!isChangeBeingEdited(change.id)"
                            >
                            </cb-text-area>
                        </div>
                    </div>
                }
            </div>
        </form>
    </mat-card-content>
</mat-card>
